const Videos = {
  CardOneVi: "https://res.cloudinary.com/divdaf0nz/video/upload/v1744643453/WE%20WORK%20PER%20HOUR/sar2kq2qpjwayqboittg.mp4",
  // Add other videos similarly
};

export default Videos;